import React from 'react';
import {useRouter} from "next/router";

const BackButton = () => {

    const router = useRouter()

    return (
        <button
            onClick={() => router.back()}
            className={'back_blog'}
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                <path fillRule="evenodd" clipRule="evenodd"
                      d="M14 1.70076e-06C6.26801 2.37671e-06 -1.42303e-06 6.26802 -7.47082e-07 14C-7.113e-08 21.732 6.26801 28 14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 1.0248e-06 14 1.70076e-06Z"
                      fill="black"/>
                <path d="M9.5 14L19 14" stroke="white" strokeWidth="2" strokeMiterlimit="10"/>
                <path d="M15 8.5L9.5 14L15 19.5" stroke="white" strokeWidth="2" strokeMiterlimit="10"/>
            </svg>
            Back
        </button>
    );
};

export default BackButton;